<template>
  <div class="view-container">
    <PageHeader title="کاربران" infoTitle="راهنمای کاربران" :infoLearnUrl="infoLearnUrl">
      <template #info>
        <p style="line-height:1.9; white-space:pre-line;">
          در این صفحه با تعریف کاربران مد نظر میتوانید به هر کدام دسترسی و نقش متفاوتی دهید. برای تعریف کاربران از بخش
          "تعریف کاربران" استفاده نمایید.
          جهت مشاهده فیلم و راهنمای کامل آموزشی بر روی لینک زیر کلیک نمایید.
        </p>
      </template>
    </PageHeader>
    <!-- Header for Users (single section, tabs removed) -->

    <!-- تعریف کاربران (تب حذف شد؛ محتویات اکنون مستقیم نمایش داده می‌شود) -->
    <div class="tab-content">
      <div class="user-definition-container">
        <div class="sub-header">
          <button class="add" @click="openUserModal">جدید</button>
          <div></div>
          <h2 class="page-title">تعریف کاربران</h2>
        </div>
        <hr class="divider-line" />

        <!-- دکمه‌های عملیات و فیلد جستجو -->
        <div class="actions-section">
          <!-- فیلد جستجو -->
          <div class="search">
            <BaseButton title="جستجو" variant="primary" @click="fetchUsers()" />
            <input id="user-search" type="text" v-model="searchQuery"
              placeholder="جستجو براساس نام، نام خانوادگی، نام کاربری، شماره همراه، شماره تلفن" />
          </div>

          <div class="actions-buttons">
            <!-- Add button moved to sub-header for consistent UI placement -->
          </div>
        </div>

        <!-- جدول کاربران -->
        <div class="table-wrapper">
          <table class="users-table">
            <thead>
              <tr>
                <th class="sticky-first">عملیات</th>
                <th>وضعیت</th>
                <th>نقش</th>
                <th>شماره تماس</th>
                <th>ایمیل</th>
                <th>نام </th>
                <th>نام و نام خانوادگی</th>
                <th>نام کاربری</th>
                <th>ردیف</th>
              </tr>
            </thead>
            <tbody>
              <tr v-if="filteredUsersList.length === 0">
                <td :colspan="9" class="empty-row">
                  هیچ کاربری ثبت نشده است. برای شروع، روی دکمه "جدید" کلیک کنید.
                </td>
              </tr>
              <tr v-for="(user, index) in filteredUsersList" :key="user.userId" @click="selectUser(user)"
                :class="{ 'selected-row': selectedUser && selectedUser.userId === user.userId }">
                <td class="actions-cell sticky-first" data-label="عملیات">
                  <button class="action-btn edit" @click.stop="handleRowEdit(user)" aria-label="ویرایش"
                    @mouseenter.stop="showFloatingTooltip($event, 'ویرایش')" @mouseleave.stop="hideFloatingTooltip()"
                    @focus.stop="showFloatingTooltip($event, 'ویرایش')" @blur.stop="hideFloatingTooltip()">
                    <img src="/img/edit.svg" alt="ویرایش" />

                  </button>
                  <button class="action-btn access" @click.stop="handleRowAccess(user)" aria-label="دسترسی ها"
                    @mouseenter.stop="showFloatingTooltip($event, 'دسترسی ها')" @mouseleave.stop="hideFloatingTooltip()"
                    @focus.stop="showFloatingTooltip($event, 'دسترسی ها')" @blur.stop="hideFloatingTooltip()">
                    <img src="/img/dastresi.svg" alt="دسترسی ها" />

                  </button>
                  <button class="action-btn delete" @click.stop="handleRowDelete(user)" aria-label="حذف"
                    @mouseenter.stop="showFloatingTooltip($event, 'حذف')" @mouseleave.stop="hideFloatingTooltip()"
                    @focus.stop="showFloatingTooltip($event, 'حذف')" @blur.stop="hideFloatingTooltip()">
                    <img src="/img/trash.svg" alt="حذف" />

                  </button>
                </td>
                <td>{{ user.isActive == true ? 'فعال' : 'غیرفعال' }}</td>
                <td>{{ user.rolePersianName }}</td>
                <td>{{ user.mobileNumber }}</td>
                <td>{{ user.email }}</td>
                <td>{{ user.lastName }}</td>
                <td>{{ user.firstName }}</td>
                <td>{{ user.userName }}</td>
                <td>{{ index + 1 }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- access-levels tab removed (UI-only) -->

    <!-- مودال فرم کاربر -->
    <div v-if="isUserModalOpen" class="modal-overlay">
      <div class="modal-content">
        <div class="sub-header">
          <ModalHeader>
            <template #default>
              <h2 class="page-title">{{ userFormMode === 'add' ? 'افزودن کاربر جدید' : 'ویرایش کاربر' }}</h2>
            </template>
          </ModalHeader>
          <div class="form-actions">
            <BaseButton title="ثبت اطلاعات" variant="primary" type="submit" form="user-form" style="margin-left: 10px;" />
            <BaseButton title="انصراف" variant="cancel" @click="closeUserModal" />
          </div>
        </div>
        <hr class="divider-line" />
        <form @submit.prevent="handleUserSubmit" class="user-form-container" id="user-form">
          <div class="top-section">
            <div class="top-form-fields">
              <div class="form-group">
                <label for="username">
                  نام کاربری <span class="required">*</span>
                </label>
                <input id="username" type="text" v-model="userForm.userName" required />
              </div>
              <div class="form-group">
                <label for="full-name">
                  نام <span class="required">*</span>
                </label>
                <input id="full-name" type="text" v-model="userForm.firstName" required />
              </div>
              <div class="form-group">
                <label for="full-name">
                  نام خانوادگی <span class="required">*</span>
                </label>
                <input id="full-name" type="text" v-model="userForm.lastName" required />
              </div>
            </div>

            <div class="bottom-form-fields">
              <div class="form-group">
                <label for="password">
                  کلمه عبور <span class="required" v-if="userFormMode === 'add'">*</span>
                </label>
                <input id="password" type="password" v-model="userForm.password" :required="userFormMode === 'add'"
                  :placeholder="userFormMode === 'edit' ? 'کلمه عبور جدید' : ''" />
              </div>
              <div class="form-group">
                <label for="phone">
                  شماره تماس
                  <span class="required">*</span>
                </label>
                <input id="phone" type="tel" v-model="userForm.mobileNumber" />
              </div>
              <div class="form-group">
                <label for="role">
                  نقش <span class="required">*</span>
                </label>
                <select id="role" v-model="userForm.roleName" required>
                  <option value="">انتخاب کنید</option>
                  <option value="Assistance_Clinic">معاونت</option>
                  <option value="Secretary_Clinic">منشی</option>
                  <option value="Doctor_Clinic">پزشک</option>
                </select>
              </div>
            </div>

            <div class="additional-form-fields">
              <!-- <div class="form-group">
                <label for="medicalGroup">نام گروه پزشکان مرتبط</label>
                <select id="medicalGroup" v-model="userForm.medicalGroup">
                  <option value="">انتخاب کنید</option>
                  <option v-for="(g, idx) in medicalGroupsOptions" :key="idx" :value="g">{{ g }}</option>
                </select>
              </div> -->
              <div class="form-group">
                <label for="email">
                  ایمیل
                </label>
                <input id="email" type="email" v-model="userForm.email" />
              </div>
              <div class="form-group">
                <label for="status">وضعیت</label>
                <select id="status" v-model="userForm.isActive">
                  <option value="true">فعال</option>
                  <option value="false">غیرفعال</option>
                </select>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- مودال فرم سطح دسترسی -->
    <div v-if="isAccessModalOpen" class="modal-overlay">
      <div class="modal-content">
        <div class="sub-header">
          <ModalHeader>
            <template #default>
              <h2 class="page-title">{{ accessFormMode === 'add' ? 'تعریف سطح دسترسی جدید' : 'ویرایش سطح دسترسی' }}</h2>
            </template>
            <template #actions>
              <button class="modal-close-btn">
                <font-awesome-icon :icon="['fas', 'arrow-right']" />
              </button>
            </template>
          </ModalHeader>
          <div class="form-actions">
            <BaseButton title="ثبت اطلاعات" variant="primary" type="submit" form="access-form" />
          </div>
        </div>
        <hr class="divider-line" />
        <form @submit.prevent="handleAccessSubmit" class="access-form-container" id="access-form">
          <div class="top-section">
            <div class="top-form-fields">
              <div class="form-group">
                <label for="access-name">
                  نام سطح دسترسی <span class="required">*</span>
                </label>
                <input id="access-name" type="text" v-model="accessForm.name" required />
              </div>
              <div class="form-group">
                <label for="access-description">توضیحات</label>
                <textarea id="access-description" v-model="accessForm.description" rows="3"></textarea>
              </div>
            </div>

            <div class="permissions-section">
              <h3>دسترسی‌ها</h3>
              <div class="permissions-grid">
                <div v-for="permission in availablePermissions" :key="permission.id" class="permission-item">
                  <label>
                    <input type="checkbox" :value="permission.id" v-model="accessForm.permissions" />
                    {{ permission.name }}
                  </label>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>

    <!-- مودال تعیین سطح دسترسی کاربر -->
    <div v-if="isUserPermissionsModalOpen" class="modal-overlay">
      <div class="modal-content">
        <div class="sub-header">
          <ModalHeader>
            <template #default>
              <h2 class="page-title">تعیین سطح دسترسی - {{ selectedUser?.fullName }}</h2>
            </template>
          </ModalHeader>
          <div class="form-actions">
            <BaseButton title="ذخیره تغییرات" variant="primary" type="submit" @click="saveUserPermissions" style="margin-left: 10px;" />
            <BaseButton title="انصراف" variant="cancel" @click="closeUserPermissionsModal" />
          </div>
        </div>
        <hr class="divider-line" />

        <!-- جدول دسترسی‌ها -->
        <div class="permissions-table-container">
          <table class="permissions-table">
            <thead>
              <tr>
                <th>مجازیت</th>
                <th>قسمت‌های سیستم</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in flattenedPermissions" :key="item.node.id"
                v-show="item.ancestors.length === 0 || item.ancestors.every(a => openCategories[a])">
                <td>
                  <input type="checkbox" :checked="isParentChecked(item.node)" @change="toggleParent(item.node)" />
                </td>
                <td
                  :style="{ paddingRight: (item.level * 18) + 'px', cursor: item.node.children && item.node.children.length ? 'pointer' : 'default' }"
                  @click="item.node.children && item.node.children.length ? toggleParentOpen(item.node.id) : null">
                  <span v-if="item.node.children && item.node.children.length" class="caret"
                    :class="{ open: openCategories[item.node.id] }">▾</span>
                  <strong v-if="item.node.children && item.node.children.length">{{ item.node.name }}</strong>
                  <span v-else>{{ item.node.name }}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <Teleport to="body">
      <div v-if="floatingTooltip.visible" class="floating-tooltip"
        :style="{ left: floatingTooltip.left + 'px', top: floatingTooltip.top + 'px' }">{{ floatingTooltip.text }}</div>
    </Teleport>
    <!-- Info is now handled inside PageHeader -->
    <!-- Global ConfirmModal is provided in App.vue and opened via useConfirm() -->
  </div>
</template>

<script setup>
import PageHeader from '@/components/PageHeader.vue';
import { ref, reactive, computed, onMounted } from "vue";
import { useFloatingTooltip } from '@/composables/useFloatingTooltip'
import ModalHeader from '@/components/ModalHeader.vue'
import BaseButton from '@/components/UiCompunents/BaseButton.vue'
import { useToast } from 'vue-toastification'
import { useConfirm } from '@/stores/composables.js'
import { useUsersStore } from '@/stores/common/users'
import { usePermissionAccessStore } from '@/stores/common/permissionAccess';
import { storeToRefs } from 'pinia';

// --- State ---
const isUserModalOpen = ref(false);
const isAccessModalOpen = ref(false);
const isUserPermissionsModalOpen = ref(false);
const accessSearchQuery = ref("");
const userFormMode = ref("add");
const accessFormMode = ref("add");
const editingUserId = ref(null);
const editingAccessId = ref(null);
const selectedUser = ref(null);
const selectedAccessLevel = ref(null);
const selectedUserPermissions = ref([]);
const initialSelectedPermissions = ref([]);
// Reactive map for which categories are opened in the permissions modal
const openCategories = ref({});
// Confirmation modal state for delete actions
// useConfirm composable is used to show global confirm modal
// Floating tooltip state (use composable)
const { floatingTooltip, showFloatingTooltip, hideFloatingTooltip } = useFloatingTooltip()

const usersStore = useUsersStore();
const permissionAccessStore = usePermissionAccessStore();
const { userList, pagination, searchQuery, loading } = storeToRefs(usersStore);
const { fetchUsers, addUser, updateUser, deleteUser } = usersStore;
const { fetchUserPermissionAsync, saveUserPermissionAccessBatch } = permissionAccessStore;
const { permissionAccessEntity } = storeToRefs(permissionAccessStore);
// Info modal link (handled by PageHeader)
const toast = useToast()
const infoLearnUrl = 'https://www.sinapardazesh.ir/matab-learning-web/'

// openInfoModal moved to PageHeader component; no local handler required

// --- User Data ---
const loadingUsers = usersStore.loading;
const filteredUsersList = computed(() => userList.value);

// fetch users when the view is mounted
onMounted(() => {
  fetchUsers();
});

// --- Access Levels Data ---
const accessLevelsList = ref([
  {
    id: 1,
    name: "مدیر کل",
    description: "دسترسی کامل به تمام بخش‌ها",
    permissions: ["users", "patients", "reports", "settings"],
    userCount: 1,
    status: "active"
  },
  {
    id: 2,
    name: "پزشک",
    description: "دسترسی به بخش بیماران و گزارش ها",
    permissions: ["patients", "reports"],
    userCount: 3,
    status: "active"
  }
]);

const availablePermissions = ref([
  { id: "users", name: "مدیریت کاربران" },
  { id: "patients", name: "مدیریت بیماران" },
  { id: "reports", name: "گزارش ها" },
  { id: "report", name: "گزارش ها" },
  { id: "settings", name: "تنظیمات" },
  { id: "inventory", name: "انبار" },
  { id: "accounting", name: "حسابداری" },
  { id: "appointment", name: "نوبت دهی" },
  { id: "bill", name: "قبوض" },
  { id: "hospitalization", name: "بستری" },
  { id: "waiting", name: "سالن انتظار" },
  { id: "financial", name: "مالی" }
]);

// --- System Permissions (loaded per-user from API) ---
const systemPermissions = ref([]);

// Helpers used when normalizing API permission items
function toSnake(s) {
  return String(s || '')
    .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
    .replace(/[.-]/g, '_')
    .replace(/\s+/g, '_')
    .toLowerCase();
}

function actionNameToId(actionName) {
  if (!actionName) return null;
  const parts = String(actionName).split('.').filter(Boolean);
  const clinicIndex = parts.findIndex(p => p.toLowerCase() === 'clinic');
  const relevant = clinicIndex >= 0 ? parts.slice(clinicIndex + 1) : parts.slice(-2);
  return toSnake(relevant.length ? relevant.join('_') : parts.join('_'));
}

// Build permission tree grouped by top-level segment or matching parent items
const permissionTree = computed(() => {
  // Prefer raw id / parentId mapping when available (id refers to API 'id')
  if (systemPermissions.value.some(p => p.rawId !== undefined)) {
    const byRaw = {};
    systemPermissions.value.forEach(p => { byRaw[p.rawId] = { ...p, children: [] }; });

    const roots = [];
    Object.values(byRaw).forEach(node => {
      // If parentId is null or missing or equals self, it's a root
      if (node.parentId == null || node.parentId === node.rawId || !byRaw[node.parentId]) {
        roots.push(node);
      } else {
        byRaw[node.parentId].children.push(node);
      }
    });

    const convert = (n) => ({ id: n.id, name: n.name, children: (n.children || []).map(convert), hasOwnPermission: true });

    const mapped = roots.map(convert);
    mapped.forEach(m => { if (openCategories.value[m.id] === undefined) openCategories.value[m.id] = true; });
    return mapped.sort((a, b) => a.name.localeCompare(b.name, 'fa'));
  }

  // Fallback: if API uses permissionId for linking (older shape), use that
  if (systemPermissions.value.some(p => p.permissionId !== undefined)) {
    const byPerm = {};
    systemPermissions.value.forEach(p => { byPerm[p.permissionId] = { ...p, children: [] }; });

    const roots = [];
    Object.values(byPerm).forEach(node => {
      if (node.parentId == null || node.parentId === node.permissionId || !byPerm[node.parentId]) {
        roots.push(node);
      } else {
        byPerm[node.parentId].children.push(node);
      }
    });

    const convert = (n) => ({ id: n.id, name: n.name, children: (n.children || []).map(convert), hasOwnPermission: true });

    const mapped = roots.map(convert);
    mapped.forEach(m => { if (openCategories.value[m.id] === undefined) openCategories.value[m.id] = true; });
    return mapped.sort((a, b) => a.name.localeCompare(b.name, 'fa'));
  }

  // Legacy heuristic fallback
  const parentsMap = {};

  // First pass: create explicit parent nodes for permissions that look like parent entries
  systemPermissions.value.forEach(p => {
    const isParent = !p.id.includes('_') || availablePermissions.value.some(a => a.id === p.id) || p.id === 'definitions' || p.id === 'doctors';
    if (isParent) {
      parentsMap[p.id] = { id: p.id, name: p.name, children: [] };
    }
  });

  // Second pass: attach children by best-guess prefix matching to existing parents
  systemPermissions.value.forEach(p => {
    if (p.id.includes('_')) {
      // attempt to attach to parent by prefix
      const prefix = p.id.split('_')[0];
      // try direct match to parent
      if (parentsMap[prefix]) {
        parentsMap[prefix].children.push(p);
        return;
      }
      // for 'define_' group, attach to 'definitions' parent if any
      if (prefix === 'define' && parentsMap['definitions']) {
        parentsMap['definitions'].children.push(p);
        return;
      }
      // fallback: try to match parent's id included in the child id
      for (const pid of Object.keys(parentsMap)) {
        if (p.id.includes(pid)) {
          parentsMap[pid].children.push(p);
          return;
        }
      }
      // fallback: create a new parent for the prefix if none exists
      if (!parentsMap[prefix]) {
        // name fallback: try to find a label entry in availablePermissions
        const ap = availablePermissions.value.find(a => a.id === prefix);
        const name = ap ? ap.name : prefix;
        parentsMap[prefix] = { id: prefix, name, children: [] };
      }
      parentsMap[prefix].children.push(p);
    }
  });

  // Ensure parents with no children are still present based on systemPermissions entries
  Object.values(parentsMap).forEach(parent => {
    if (!parent.children || parent.children.length === 0) {
      // leave as is: empty parents are allowed
    }
    // mark whether the parent itself is a permission (exists in systemPermissions)
    parent.hasOwnPermission = !!systemPermissions.value.find(p => p.id === parent.id);
  });

  // Initialize openCategories for UI defaults if not present
  Object.keys(parentsMap).forEach(pid => {
    if (openCategories.value[pid] === undefined) openCategories.value[pid] = true; // expand by default
  });

  // Return a sorted tree by parent name (optional)
  return Object.values(parentsMap).sort((a, b) => a.name.localeCompare(b.name, 'fa'));
});

const flattenedPermissions = computed(() => {
  const out = [];
  function walk(node, ancestors = []) {
    out.push({ node, level: ancestors.length, ancestors });
    (node.children || []).forEach(child => walk(child, ancestors.concat(node.id)));
  }
  permissionTree.value.forEach(root => walk(root, []));
  return out;
});

// --- Forms ---
const initialUserFormState = {
  userId: "",
  roleId: "",
  userName: "",
  firstName: "",
  lastName: "",
  email: "",
  normalizedUserName: "",
  normalizedEmail: "",
  phoneNumber: "",
  mobileNumber: "",
  roleName: "",
  isActive: true,
  userImageString: "",
  password: "",
  birthDatePersian: "",
  address: "",
  postalCode: ""
};

const initialAccessFormState = {
  name: "",
  description: "",
  permissions: []
};

let userForm = reactive({ ...initialUserFormState });
let accessForm = reactive({ ...initialAccessFormState });

// --- Computed ---

const filteredAccessLevelsList = computed(() => {
  if (!accessSearchQuery.value.trim()) return accessLevelsList.value;

  const query = accessSearchQuery.value.toLowerCase().trim();

  return accessLevelsList.value.filter((level) => {
    return (
      (level.name && level.name.toLowerCase().includes(query)) ||
      (level.description && level.description.toLowerCase().includes(query))
    );
  });
});

// --- Doctor groups for dropdown ---
const medicalGroupsOptions = computed(() => {
  const groups = filteredUsersList.value
    .map(u => u.medicalGroup)
    .filter(g => g && g.trim());
  // unique values in original order
  return [...new Set(groups)];
});

// --- Search button helpers ---
function applyUserSearch() {
  // trim to normalize and trigger recompute of computed list
  searchQuery.value = searchQuery.value ? searchQuery.value.trim() : "";
}

function applyAccessSearch() {
  // The access tab lists users for assigning permissions, so trim the main searchQuery
  searchQuery.value = searchQuery.value ? searchQuery.value.trim() : "";
}

// --- Methods ---
function openUserModal() {
  userFormMode.value = "add";
  editingUserId.value = null;
  Object.assign(userForm, initialUserFormState);
  isUserModalOpen.value = true;
}

function closeUserModal() {
  isUserModalOpen.value = false;
  Object.assign(userForm, initialUserFormState);
}

function openAccessModal() {
  accessFormMode.value = "add";
  editingAccessId.value = null;
  Object.assign(accessForm, initialAccessFormState);
  isAccessModalOpen.value = true;
}

function closeAccessModal() {
  isAccessModalOpen.value = false;
  Object.assign(accessForm, initialAccessFormState);
}

function selectUser(user) {
  selectedUser.value = user;
}

// Row actions used by buttons in the actions column
function handleRowEdit(user) {
  console.log(user);
  selectedUser.value = user;
  editUser();
}

async function handleRowDelete(user) {
  selectedUser.value = user;
  const { confirm } = useConfirm();
  const confirmed = await confirm({
    title: `${user.userName} حذف کاربر`,
    message: `آیا از حذف کاربر مطمئن هستید؟ این عملیات برگشت‌ ناپذیر است.`,
    confirmText: 'بله، حذف شود',
    cancelText: 'انصراف'
  })
  if (!confirmed) return;
  performDeleteUser();
}

function handleRowPermissions(user) {
  selectedUser.value = user;
  openUserPermissionsModal();
}

function handleRowAccess(user) {
  selectedUser.value = user;
  // Use the existing permissions modal as the access UI
  openUserPermissionsModal();
}

function editUser() {
  if (!selectedUser.value) return;

  userFormMode.value = "edit";
  editingUserId.value = selectedUser.value.userId;
  Object.assign(userForm, {
    userId: selectedUser.value.userId,
    roleId: selectedUser.value.roleId,
    userName: selectedUser.value.userName,
    firstName: selectedUser.value.firstName,
    lastName: selectedUser.value.lastName,
    email: selectedUser.value.email,
    mobileNumber: selectedUser.value.mobileNumber,
    roleName: selectedUser.value.roleName,
    isActive: selectedUser.value.isActive
  });
  isUserModalOpen.value = true;
}

async function performDeleteUser() {
  if (!selectedUser.value) return;
  await deleteUser(selectedUser.value.userId)
}

async function handleUserSubmit() {
  if (userForm.isActive === "true")
    userForm.isActive = true;
  else
    userForm.isActive = false;
  if (userFormMode.value === "add") {
    const newUser = {
      ...userForm,
    };
    await addUser({ ...newUser });
  } else {
    await updateUser({ ...userForm });
  }

  closeUserModal();
}

function handleAccessSubmit() {
  if (accessFormMode.value === "add") {
    const newLevel = {
      id: Date.now(),
      ...accessForm,
      userCount: 0,
      status: "active"
    };
    accessLevelsList.value.push(newLevel);
  } else {
    const index = accessLevelsList.value.findIndex(l => l.id === editingAccessId.value);
    if (index > -1) {
      accessLevelsList.value[index] = { ...accessLevelsList.value[index], ...accessForm };
    }
  }

  closeAccessModal();
  alert("اطلاعات سطح دسترسی با موفقیت ثبت شد.");
}

async function openUserPermissionsModal() {
  if (!selectedUser.value) return;
  // Always fetch fresh permissions for the selected user from API
  try {
    // fetchUserPermissionAsync returns an array of items with { id, parentId, name, actionName, hasAccess }
    const resp = await fetchUserPermissionAsync(selectedUser.value.userId);
    const src = Array.isArray(resp) ? resp : (Array.isArray(permissionAccessEntity) ? permissionAccessEntity : []);
    // normalize items into our expected flat shape (rawId, id, name, parentId, hasAccess)
    const normalized = src.map(p => {
      const codeId = p.actionName ? actionNameToId(p.actionName) : (p.name ? toSnake(p.name) : String(p.id));
      return {
        // IMPORTANT:
        // - rawId: record id in the list response (often used for parentId relationships)
        // - permissionAccessId: identifier used by backend for save/edit
        rawId: p.id,
        permissionAccessId: p.permissionAccessId == null ? null : p.permissionAccessId,
        id: codeId || String(p.id),
        name: p.name || p.actionName || String(p.id),
        parentId: p.parentId == null ? null : p.parentId,
        hasAccess: !!p.hasAccess,
        actionName: p.actionName || null
      };
    }).filter(Boolean);

    // replace systemPermissions with fresh normalized data
    systemPermissions.value = normalized;

    // pre-select permissions where hasAccess === true
    // IMPORTANT: the UI (tree + toggle handlers) uses `node.id`, so our selection arrays must store `id`.
    selectedUserPermissions.value = normalized.filter(x => x.hasAccess).map(x => x.id);

    // snapshot baseline selection so we can compute diffs (including removals)
    initialSelectedPermissions.value = [...selectedUserPermissions.value];

    // ensure top-level categories are expanded by default if not set
    normalized.filter(x => !x.parentId).forEach(p => { if (openCategories.value[p.id] === undefined) openCategories.value[p.id] = true; });
  } catch (err) {
    console.error('Failed to load user permissions:', err);
    // fallback to existing selectedUser permissions (if any)
    selectedUserPermissions.value = [...(selectedUser.value.permissions || [])];
  }

  isUserPermissionsModalOpen.value = true;
}

function closeUserPermissionsModal() {
  isUserPermissionsModalOpen.value = false;
  selectedUserPermissions.value = [];
}


function isParentChecked(parent) {
  // parent may represent a group; if it has its own permission, ensure it is included too
  const childIds = (parent.children || []).map(c => c.id);
  const allChildrenChecked = childIds.length === 0 ? true : childIds.every(c => selectedUserPermissions.value.includes(c));
  if (parent.hasOwnPermission) {
    return allChildrenChecked && selectedUserPermissions.value.includes(parent.id);
  }
  return allChildrenChecked;
}

function toggleParent(parent) {
  const childIds = (parent.children || []).map(c => c.id);
  const toggles = [...childIds];
  if (parent.hasOwnPermission) toggles.push(parent.id);
  // if all checked, uncheck all; else check all
  const allChecked = toggles.every(id => selectedUserPermissions.value.includes(id));
  if (allChecked) {
    // remove children
    selectedUserPermissions.value = selectedUserPermissions.value.filter(id => !toggles.includes(id));
  } else {
    // ensure all child ids exist
    const newSet = new Set(selectedUserPermissions.value);
    toggles.forEach(id => newSet.add(id));
    selectedUserPermissions.value = Array.from(newSet);
  }
}

function toggleParentOpen(categoryId) {
  openCategories.value[categoryId] = !openCategories.value[categoryId];
}

async function saveUserPermissions() {
  if (!selectedUser.value) return;

  // backend expects ONLY changes (diffs):
  // { id, permissionAccessId, userId, actionName, hasAccess }
  // NOTE about id:
  // - for existing records, backend expects the persisted row id
  // - for new rows, send 0
  const initialSet = new Set(initialSelectedPermissions.value || []);
  const currentSet = new Set(selectedUserPermissions.value || []);

  const changedPayload = (systemPermissions.value || [])
    .filter(p => {
      const was = initialSet.has(p.id);
      const now = currentSet.has(p.id);
      return was !== now;
    })
    .map(p => {
      const hasAccess = currentSet.has(p.id);
      return {
        // Prefer rawId if it looks like a persisted record id; otherwise fall back to permissionAccessId; else 0.
        id: typeof p.rawId === 'number' ? p.rawId : (typeof p.permissionAccessId === 'number' ? p.permissionAccessId : 0),
        permissionAccessId: typeof p.permissionAccessId === 'number' ? p.permissionAccessId : 0,
        userId: selectedUser.value.userId,
        actionName: p.actionName || p.name || p.id,
        hasAccess: !!hasAccess
      };
    });

  if (changedPayload.length === 0) {
    toast.info('هیچ تغییری برای ذخیره وجود ندارد.');
    return;
  }

  try {
    await saveUserPermissionAccessBatch(changedPayload);

    // Sync baseline so repeated saves in the same modal session don't resend same diffs
    initialSelectedPermissions.value = [...selectedUserPermissions.value];

    // Update local view (best-effort)
    const userIndex = filteredUsersList.value.findIndex(u => u.userId === selectedUser.value.userId);
    if (userIndex > -1) {
      filteredUsersList.value[userIndex].permissions = [...selectedUserPermissions.value];
    }

    closeUserPermissionsModal();
  } catch (e) {
    // store already shows toast; keep modal open so user can retry
    console.error(e);
  }
}

</script>

<style scoped>
.view-container {
  display: flex;
  flex-direction: column;
  gap: 10px;
  padding: 20px;
}

.header {
  width: 100%;
  text-align: right;
  color: var(--text-color-primary);
  padding: 10px;
  border-radius: 20px;
}

/* spacing for page header */
.view-container>.header {
  margin-bottom: 0;
}

/* تب‌ها */
.reports-tabs {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  border-bottom: 2px solid var(--text-color-secondary);
  flex-wrap: wrap;
}

.tabs-container {
  display: flex;
  gap: 0;
}

/* submit-button styles removed — submit buttons now use BaseButton (variant="primary") */

.tab-button.active {
  color: var(--text-color-primary);
  border-bottom-color: var(--text-color-primary);
  background-color: var(--background-color-secondary);
}

.tab-content {
  background: var(--background-color);
  border-radius: 8px;
  padding: 25px;
  direction: ltr;
}

.sub-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  color: var(--text-color-secondary);
}

.sub-header h2 {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
  color: var(--text-color-primary);
}

/* add button styling to match other pages */
.sub-header .add {
  display: flex;
  align-items: center;
  padding: 10px 22px;
  border-radius: 10px;
  border: none;
  cursor: pointer;
  background-color: var(--background-color-button);
  color: var(--background-color);
}

.sub-header .add:hover {
  background-color: var(--background-color-button-hover);
}

.divider-line {
  /* Use global centralized divider style; keep consistent margins for this view */
  width: 100%;
  padding: 0px;
  margin: 15px auto;
  border: none;
  border-top: 1px solid rgba(var(--text-color-secondary-rgb), 0.3);
  background-color: transparent;
}

/* بخش دکمه‌ها و جستجو */
.actions-section {
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
  flex-wrap: wrap;
  gap: 15px;
}

/* دکمه‌های عملیات */
.actions-buttons {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.btn {
  padding: 8px 16px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s ease-in-out;
}

.btn-sm {
  padding: 4px 8px;
  font-size: 12px;
}

.btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.btn-primary {
  background-color: var(--background-color-button);
  color: var(--text-color-forthly);
}

.btn-primary:hover:not(:disabled) {
  background-color: var(--background-color-button);
  opacity: 0.8;
}

.btn-secondary {
  background-color: var(--background-color-secondary);
  color: var(--text-color-primary);
  border: 1px solid var(--text-color-secondary);
}

.btn-secondary:hover:not(:disabled) {
  background-color: var(--background-color-secondary);
  opacity: 0.8;
}

/* فیلد جستجو */
.search {
  display: flex;
  gap: 8px;
  align-items: center;
  /* Make search take available space next to action buttons */
  flex: 1 1 auto;
  min-width: 0;
  /* allow shrinking in overflow situations */
}

.search>input#user-search,
.search>input#access-search {
  /* allow the input to expand to fill the search container */
  flex: 1 1 auto;
  width: auto;
  min-width: 0;
  padding: 8px 12px;
  border: 1px solid var(--text-color-secondary);
  border-radius: 10px;
  text-align: right;
  direction: rtl;
  background-color: var(--background-color);
  color: var(--text-color-primary);
}

/* submit-button styles removed — use BaseButton (variant="primary") */
/* جدول */
.table-wrapper {
  overflow: auto;
  max-height: 70vh;
  /* Use a lighter border color consistent with other tables */
  border: 1px solid rgba(var(--text-color-secondary-rgb), 0.06);
  border-radius: 10px;
}

.users-table,
.access-levels-table {
  width: 100%;
  text-align: right;
  font-size: calc(0.3vw + 8px);
  color: var(--text-color-primary);
  border-collapse: separate;
  border-spacing: 0;
}

.users-table th,
.users-table td,
.access-levels-table th,
.access-levels-table td {
  padding: 12px 15px;
  /* Lighter divider line for readability and consistency */
  border-bottom: 1px solid rgba(var(--text-color-secondary-rgb), 0.06);
  white-space: nowrap;
}

.users-table td,
.access-levels-table td {
  /* low-opacity left border like other tables */
  border-left: 1px solid rgba(var(--text-color-secondary-rgb), 0.06);
}

.users-table td:last-child,
.access-levels-table td:last-child {
  border-left: none;
}

.users-table thead,
.access-levels-table thead {
  background-color: var(--hover-background-color);
}

.users-table th,
.access-levels-table th {
  position: sticky;
  top: 0;
  z-index: 2;
  font-weight: bold;
  border-left: 1px solid rgba(var(--text-color-secondary-rgb), 0.06);
}

.users-table th:last-child,
.access-levels-table th:last-child {
  border-left: none;
}

/* Make the LAST column sticky so actions remain visible on horizontal scroll */
.users-table th.sticky-first,
.users-table td.sticky-first {
  position: sticky;
  left: 0;
  /* put the sticky column above normal rows so it hides content underneath */
  z-index: 4;
  box-shadow: 10px 0px 10px -5px rgba(var(--text-color-secondary-rgb), 0.25);
  /* ensure the column has an opaque background to hide content scrolling under it */
  background-color: var(--hover-background-color);
  /* keep a subtle right border to visually separate the column from the table content */
  border-right: 1px solid rgba(var(--text-color-secondary-rgb), 0.12);
}

.users-table th.sticky-first {
  background-color: var(--hover-background-color);
  /* header should sit above the td sticky so increase z-index */
  z-index: 5;
  /* keep header above rows and cells */
}

.actions-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.action-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 6px;
  margin: 0;
  background-color: transparent;
  border: none;
  cursor: pointer;
  font-size: calc(0.2vw + 14px);
  height: 32px;
  min-height: 32px;
  width: 32px;
  border-radius: 6px;
  position: relative;
  /* for absolute-positioned tooltip */
}

.action-btn img {
  width: 18px;
  height: 18px;
}

.action-btn .svg-inline--fa,
.action-btn .fa-icon,
.action-btn svg {
  font-size: 14px;
  /* fontawesome pattern */
  width: 18px;
  height: 18px;
}

.action-btn.role img,
.action-btn.access img {
  filter: none;
  /* ensure svg renders as-is */
}

/* Inline tooltip CSS removed — we now rely on the floating tooltip composable and teleport. */

/* Floating tooltip style centralized in src/assets/Style.scss - removed per-view duplicate to keep consistent opacity */

.action-btn .edit {
  color: #1476f3;
}

.action-btn .delete {
  color: #ff0f0f;
}

.action-btn .archive {
  color: #db9501;
}

.users-table tbody tr,
.access-levels-table tbody tr {
  cursor: pointer;
}

.users-table tbody tr:hover,
.access-levels-table tbody tr:hover {
  background-color: rgba(var(--text-color-secondary-rgb), 0.5);
}

.selected-row {
  background-color: rgba(23, 162, 184, 0.2) !important;
}

.empty-row td {
  text-align: center;
  padding: 40px;
  color: var(--text-color-secondary);
}

/* فرم */
.user-form-container,
.access-form-container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.top-section {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* `.submit-button` removed — use `BaseButton` (variant="primary") for submit actions */

.permission-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group label {
  margin-bottom: 5px;
  color: var(--tex-color-thirdly);
  text-align: justify;
}

.required {
  color: #ff0f0f;
  margin-right: 4px;
}

.form-group input,
.form-group select,
.form-group textarea {
  padding: 8px 12px;
  border: 1px solid var(--text-color-secondary);
  border-radius: 10px;
  text-align: right;
  direction: rtl;
  width: 100%;
  background-color: var(--background-color-secondary);
  color: var(--text-color-primary);
}

.form-group input,
.form-group select {
  height: 40px;
}

.form-group input:focus,
.form-group select:focus,
.form-group textarea:focus {
  outline: none;
  border-color: var(--text-color-primary);
}

.form-actions {
  display: flex;
  justify-content: flex-start;
}

/* `.submit-button` styles removed — use `BaseButton` (variant="primary") for submit actions */

/* مودال */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: calc(100dvh - 65px);
  margin-top: 65px;
  background-color: rgba(var(--text-color-secondary-rgb), 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background-color: var(--background-color);
  padding: 20px;
  border-radius: 30px;
  border: 1px solid var(--text-color-secondary);
  width: auto;
  max-height: 90vh;
  /* submit-button replaced by BaseButton (variant="primary") */
  font-size: calc(0.3vw + 12px);
  color: var(--text-color-secondary);
  background-color: transparent;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.modal-header {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5px;
}

/* رسپانسیو */
@media (max-width: 768px) {
  .reports-tabs {
    justify-content: center;
  }

  /* submit-button styles removed — submit buttons now use BaseButton (variant="primary") */
  .actions-section {
    flex-direction: column;
    align-items: stretch;
  }

  .actions-buttons {
    justify-content: center;
    margin-bottom: 10px;
  }

  .search {
    min-width: unset;
    max-width: unset;
  }

  .btn {
    width: 100%;
  }
}

/* جدول دسترسی‌ها */
.permissions-table-container {
  max-height: 60vh;
  overflow-y: auto;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
}

.permissions-table {
  width: 100%;
  text-align: right;
  font-size: calc(0.3vw + 8px);
  color: var(--text-color-primary);
  border-collapse: separate;
  border-spacing: 0;
}

.permissions-table th,
.permissions-table td {
  padding: 12px 15px;
  border-bottom: 1px solid #e5e7eb;
  white-space: nowrap;
}

.permissions-table td {
  border-left: 1px solid #e5e7eb;
}

.permissions-table td:last-child {
  border-left: none;
}

/* Nested permission child row styling */
.permission-child-row td.child-name {
  /* indent child rows — for RTL, use padding-right */
  padding-right: 26px;
}

.permission-parent-row td {
  background-color: rgba(var(--text-color-secondary-rgb), 0.03);
}

.caret {
  display: inline-block;
  transform: rotate(-90deg);
  margin-left: 8px;
  transition: transform 0.12s;
}

.caret.open {
  transform: rotate(0deg);
}

.permissions-table thead {
  background-color: var(--hover-background-color);
  position: sticky;
  top: 0;
  z-index: 2;
}

.permissions-table th {
  font-weight: bold;
  border-left: 1px solid #e5e7eb;
}

.permissions-table th:last-child {
  border-left: none;
}

.permissions-table tbody tr:hover {
  background-color: rgba(var(--text-color-secondary-rgb), 0.5);
}

.permissions-table input[type="checkbox"] {
  width: 18px;
  height: 18px;
  cursor: pointer;
}
</style>
